export const accordionStyles = {
  margin: "0px !important",
  boxShadow: "none !important",
  border: "1px solid rgba(234, 234, 234, 1)",
  borderBottom: "none",
  "&:first-child": {
    borderTopLeftRadius: "8px",
    borderTopRightRadius: "8px",
  },
  "&:last-child": {
    borderBottom: "1px solid rgba(234, 234, 234, 1)",
    borderBottomLeftRadius: "8px",
    borderBottomRightRadius: "8px",
    overflow: "hidden",
  },
  "&::before": {
    display: "none",
  },

  "&.MuiPaper-root": {
    backgroundColor: "rgba(255, 255, 255, 1) !important",
  },
};

export const accordionSummaryStyles = {
  minHeight: "68px !important",
  borderBottom: "1px solid transparent",
  paddingX: "11px !important",
  "&.Mui-expanded": {
    borderBottom: "1px solid rgba(234, 234, 234, 1)",
  },
  "& .MuiAccordionSummary-content": {
    alignItems: "center",
    margin: "0px !important",
  },

  opacity: "1 !important",

  "&.Mui-disabled svg": {
    opacity: 0.5,
  },
};

export const iconStyles = {
  transform: "rotate(0deg)",
  transition: "transform 0.3s",
  mr: "4px",
  color: "rgba(62, 63, 76, 1)",
  fontSize: "20px",
  ".Mui-expanded &": {
    transform: "rotate(90deg)",
  },
};

export const accordionDetailsStyles = {
  backgroundColor: "#f8f7fa",
  padding: "0px",
};

export const tableContainerStyles = (isSmallScreen) => ({
  maxHeight: 400,
  overflow: "auto",
  borderTopLeftRadius: isSmallScreen && "0px",
  borderTopRightRadius: isSmallScreen && "0px",
  borderBottom: "none",
  scrollbarWidth: "none",
  "&::-webkit-scrollbar": {
    display: "none",
  },
  "& th": {
    color: "rgba(72, 72, 72, 0.7)",
    fontSize: "13px",
    fontWeight: 400,
    lineHeight: "18px",
    paddingY: "16px",
    paddingX: "12px",
    borderLeft: "1px solid rgba(234, 234, 234, 1)",
    background: "#f8f7fa",
    whiteSpace: "nowrap",
  },
  "& td": {
    color: "rgba(72, 72, 72, 1)",
    fontSize: "14px",
    fontWeight: 400,
    lineHeight: "20px",
    padding: "12px",
    height: "44px",
    borderLeft: "1px solid rgba(234, 234, 234, 1)",
    background: "#f8f7fa",
    whiteSpace: "nowrap",
  },

  "tbody tr:last-child td": {
    borderBottom: "none !important",
  },
});
